export default {
  CONNECTED: "connected",
};
